import { useCallback } from 'react';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import LaunchIcon from '@mui/icons-material/Launch';
import { useTheme } from '@mui/material/styles';

function NRLink({ tooltipTitle, text, url, color, showExternalIcon = true, sx: sxProp, ...linkProps }) {
  const theme = useTheme();
  const hasUrl = Boolean(url);

  const handleClick = useCallback(
    event => {
      if (!hasUrl) {
        event.preventDefault();
      }
    },
    [hasUrl]
  );

  return (
    <Tooltip tabIndex={-1} title={tooltipTitle || ''}>
      <Link
        href={hasUrl ? url : '#'}
        target={hasUrl ? '_blank' : undefined}
        rel={hasUrl ? 'noopener noreferrer' : undefined}
        onClick={handleClick}
        tabIndex={hasUrl ? 0 : -1}
        {...linkProps}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          textDecoration: 'none',
          cursor: 'pointer',
          color: color || theme.palette.blue.link,
          ...sxProp
        }}
      >
        <span
          style={{
            flex: '1 1 auto',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={text || url}
        >
          {text || url}
        </span>
        {showExternalIcon && !!(text || url) && (
          <LaunchIcon
            style={{
              flex: '0 0 auto',
              width: 16,
              height: 16,
              marginLeft: 4,
              marginBottom: -3,
              marginTop: -4,
              color: theme.palette.text.secondary
            }}
            aria-hidden
          />
        )}
      </Link>
    </Tooltip>
  );
}

export default NRLink;
